<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="「ペルソナ５ タクティカ」期間限定コラボ開始！"/>
    <div data-v-1ae908a8="">
      <div data-v-1ae908a8="" class="text-area">23.11.13<br><br>ペルソナ５シリーズ最新作「ペルソナ５ タクティカ」と期間限定コラボ！<br><br>
        <center><img src="@/assets/Png/News/P5T/joker_right.png" style="max-width: 60%;"></center>
        <br><br>
        心の怪盗団メンバーの他、新キャラクターたちもプリクラに登場☆<br><br>
        <img src="@/assets/Png/News/P5T/mainvisual.png" style="max-width: 100%;">
        <br><br>
        ■実施期間<br>
        2023.11.13(月)～2023.12.20(水)<br><br>
        ■対象機種<br>
        全国の「romakyun(ろまきゅん)」<br><br>
        <center><a href="https://puri.sega.jp/info/p5t/">遊べるお店はこちら</a></center>
        <br><br>
        <center><img src="@/assets/Png/News/P5T/Kyoutai_romakyun.png" style="max-width: 85%;"></center>
        <br><br>
        全国限定5台！<br>
        特別デザインの「romakyun」も登場します。<br><br>
        ■設置店舗<br>
        ⚡ＧｉＧＯ仙台<br>
        ⚡ＧｉＧＯ総本店<br>
        ⚡ＧｉＧＯ池袋2号館<br>
        ⚡ＧｉＧＯマーケットスクエアささしま<br>
        ⚡ラウンドワン千日前店<br><br>
        更に！<br>
        11.25(土)開催の「アミューズメント
        エキスポ in 東京ビッグサイト」にも2台出展！<br>
        会場で体験された方には「P5T オリジナルステッカー」をプレゼント！ご来場の際は是非セガブースへお立ち寄りください。<br><br>
        <img src="@/assets/Png/News/P5T/gaisou_center.png" style="max-width: 100%;">
        <br><br>
        <center>
          <a href="https://puri.sega.jp/info/p5t/">遊べるお店はこちら</a>
        </center>
        <br><br>
        <center>
          <img src="@/assets/Png/News/P5T/elle_right.png" style="max-width: 60%;">
        </center>
        <br><br>
        ■内容
        <br>《自分だけの「ペルソナ５ タクティカ」プリクラをつくろう！》<br><br>
        キャラクターなどのスタンプは全36種！<br>
        更に、オリジナルデザインのフレーム2種と、コラボ限定シールデザインも1種追加！<br><br>
        <img src="@/assets/Png/News/P5T/rakugaki.png" style="max-width: 100%;"><br><br>
        <img src="@/assets/Png/News/P5T/stamp.png" style="max-width: 100%;"><br><br>
        <center>☆★☆★☆★☆★☆★☆★☆</center>
        <br>
        「romakyun」をもっと楽しむために♪<br><br>
        シールが出てきたら、連動アプリ『プリクラON』でプリデータのダウンロードも忘れずに♪<br><br>
        ダウンロードすると、<br>
        3秒動画「モーメント」も見れるよ！<br>
        SNSにもアップしてね♪<br><br>
        プリクラONのカメラで<br>
        撮影したシールを見ると<br>
        シールが動く「ARプリクラ」も<br>
        楽しめるからこちらも試してみてね♪<br><br>
        <center>☆★☆★☆★☆★☆★☆★☆</center><br>
        《BGMも「ペルソナ５ タクティカ」の楽曲が登場！》<br><br>
        受付で「コラボモード」を選んだら、そこから先は、心を震わすギターサウンドに！<br><br>
        聴ける曲はこの3曲！<br>
        「Revolution in your Heart」<br>
        「Got Your Tail」<br>「Truth or Dare」<br><br>
        是非、お店でご体感ください。<br><br>
        <center>
          <a href="https://puri.sega.jp/info/p5t/">遊べるお店はこちら</a>
        </center><br><br>
        <center><img src="@/assets/Png/News/P5T/mona_right.png" style="max-width: 60%;"></center>
        <br><br>
        ■「ペルソナ５ タクティカ」とは？<br><br>
        <center><img src="@/assets/Png/News/P5T/catch_copy_3.png" style="max-width: 80%;"></center>
        <br>
        昼は学生、夜は「心を盗む怪盗」として過ごす痛快な世直し劇が多くの方に愛されたピカレスク・ジュヴナイルRPG『ペルソナ５』。<br>
        シリーズ最新作の本作は、バトルの魅力はそのままに仲間との連携が気持ちいいシミュレーションRPGになって登場！<br>
        怪盗団が駆け抜ける革命劇をご覧あれ！<br><br>
        <center>――――――――――――――――――――――――――</center>
        発売日：2023年11月17日(金)予定<br>
        プラットフォーム：Xbox Game Pass / Xbox Series X|S / Xbox One / Windows /PlayStation®5 / PlayStation® 4 / Nintendo Switch™ / Steam<br>
        公式サイト：<a href="https://p5t.jp/">https://p5t.jp/</a>
        <center>――――――――――――――――――――――――――</center>
        <br><br>
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
          <a class="snsIcon" href="https://lin.ee/BncFzGc">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_03_LINE.jpg">
          </a>
          <a class="snsIcon" href="https://www.tiktok.com/@sega_purikura">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_04_TT.jpg">
          </a>
        </div>
        <div class="centerBlock">
          <a href="https://www.instagram.com/sega_purikura/">Instagram</a>
          <a href="https://twitter.com/SEGA_purikura/">X(旧Twitter)</a>
          <a href="https://lin.ee/BncFzGc">LINE</a>
          <a href="https://www.tiktok.com/@sega_purikura">TikTok</a>
          <br><br>
        </div>
        <br><br>
        ©SEGA<br>
        ©ATLUS ©SEGA All rights
        reserved.
      </div>
      <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
      <sub-btn @click="onHome()">ホームに戻る</sub-btn>
    </div>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

export default {
  name: "NewsDetail",
  components: { SectionHeader, SubBtn },
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  methods: {
    onNewsList() {
      this.$router.push('/newsList')
    },
    onHome() {
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
      max-width: 100%;
    }

    .edge {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.12);
    }

    p {
      margin-top: 1em;
    }

    .linkArea {
      .twitter {
        margin: 0 5px;
      }
    }

    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 15px;
      }
      &>a:nth-of-type(2){
        margin-right: 20px;
      }
    }

    .centerBlock {
      display: flex;
      justify-content: center;

      &>a:not(:last-of-type) {
        margin-right: 26px;
      }

      &>a:last-of-type {
        margin-left: 18px;
      }
    }
  }
}</style>
